export default {
      id: "print-receipt-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#print-receipt",
      toString: function () {
        return this.url;
      }
    }